import { query, mutate } from '@/api/graphql';
import gql from 'graphql-tag';
import { always, mapObjIndexed, when } from 'ramda';
import GetAuthor from './graphql/queries/GetAuthor.graphql';
import GetAuthors from './graphql/queries/GetAuthors.graphql';
import SaveAuthor from './graphql/mutations/SaveAuthor.graphql';
import Author from './graphql/fragments/author.graphql';
import isNullOrEmpty from '../../helpers/misc/isNullOrEmpty';

export const getAuthor = async (id, newValue) => {
  const variables = {
    id,
    ...(newValue ? { siteId: newValue } : {}),
  };

  const { author } = await query(GetAuthor, variables);

  return author;
};

export const getApprovedAuthors = async () => {
  const variables = {
    filter: {
      isApproved: true,
    },
    page: 0,
    limit: 0,
  };

  const { authors } = await query(GetAuthors, variables);

  return authors;
};

export const getAuthors = async ({ filter, page, limit }) => {
  const language = localStorage.getItem('selectedLocale');
  const modifiedFilter = mapObjIndexed(when(isNullOrEmpty, always(undefined)), filter);

  const variables = {
    filter: { ...modifiedFilter },
    page,
    limit,
    language,
  };

  const { authors } = await query(gql`
    ${GetAuthors}
    ${Author}
  `,
  variables);

  return authors;
};

export const getAllAuthors = async () => {
  const language = localStorage.getItem('selectedLocale');

  const variables = {
    filter: {},
    page: 0,
    limit: 0,
    language,
  };

  const { authors } = await query(gql`
    ${GetAuthors}
    ${Author}
  `, variables);

  return authors;
};

export const saveAuthor = async input => {
  const variables = {
    input,
  };

  const result = await mutate(gql`
    ${SaveAuthor}
  `,
  variables);

  return result;
};
